import Cookies from 'js-cookie';
import localforage from 'localforage';
import { StorageConstants } from '@linkie/shared';

export const clearStaleAuth = async (): Promise<void> => {
  Cookies.remove('user_access_token', { path: '/' });
  Cookies.remove('user_access_token');
  Cookies.remove('nolt_token', { path: '/' });
  Cookies.remove('nolt_token');
  Cookies.remove('pageId', { path: '/' });
  Cookies.remove('pageId');

  await Promise.all([
    localforage.removeItem(StorageConstants.PLAYGROUND_STORE),
    localforage.removeItem(StorageConstants.IDENTITY),
  ]);
};
